export default __webpack_public_path__ + "static/media/logo.eb8620b4.svg";